export const CREATE_POST_REQUEST="CREATE_POST_REQUEST"
export const CREATE_POST_SUCCESS="CREATE_POST_SUCCESS"
export const CREATE_POST_FAILUER="CREATE_POST_FAILURE"

export const GET_ALL_POST_REQUEST="GET_ALL_POST_REQUEST"
export const GET_ALL_POST_SUCCESS="GET_ALL_POST_SUCCESS"
export const GET_ALL_POST_FAILUER="GET_ALL_POST_FAILURE"

export const LIKE_POST_REQUEST="LIKE_POST_REQUEST"
export const LIKE_POST_SUCCESS="LIKE_POST_SUCCESS"
export const LIKE_POST_FAILUER="LIKE_POST_FAILURE"

export const SAVE_POST_REQUEST="SAVE_POST_REQUEST"
export const SAVE_POST_SUCCESS="SAVE_POST_SUCCESS"
export const SAVE_POST_FAILUER="SAVE_POST_FAILURE"

export const REPOST_POST_REQUEST="REPOST_POST_REQUEST"
export const REPOST_POST_SUCCESS="REPOST_POST_SUCCESS"
export const REPOST_POST_FAILUER="REPOST_POST_FAILURE"

export const GET_USERS_POST_REQUEST="GET_USERS_POST_REQUEST"
export const GET_USERS_POST_SUCCESS="GET_USERS_POST_SUCCESS"
export const GET_USERS_POST_FAILUER="GET_USERS_POST_FAILURE"